/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Grid, Typography, Divider } from "@mui/material";
import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import Modal from "../../../components/common/Modal/Modal";
import Button from "../../../components/common/Button";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import Gohonzon from "../../../services/api/gohonzon";

function GohonzonDeleteModal({ open, onClose, application, onRefresh }) {
  const toast = useContext(ToastAlertContext);

  const handleDelete = async () => {
    try {
      await Gohonzon.gohonzonEntryDelete(application?.applicationId);
      toast.show("Gohonzon deleted successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        window.location.reload();
        onRefresh();
        onClose();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          p: { xs: 2, sm: 3 },
          boxShadow: "0px 6px 18px rgba(0,0,0,0.08)",
          maxWidth: "600px",
          mx: "auto",
        }}
      >
        {/* Header */}
        <Typography
          sx={{
            color: "#b91c1c",
            fontSize: "22px",
            fontWeight: 700,
            textAlign: "center",
            mb: 2,
          }}
        >
          Delete Gohonzon Entry
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {/* Details Section */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Member Name
            </Typography>
            <Typography fontWeight={500}>
              {application?.membername || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Member ID
            </Typography>
            <Typography fontWeight={500}>
              {application?.memberId || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Gohonzon Type
            </Typography>
            <Typography fontWeight={500}>
              {application?.type === "GOHONZON"
                ? "Okataki Gohonzon"
                : "Omamori Gohonzon"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Application Date
            </Typography>
            <Typography fontWeight={500}>
              {application?.applicationDate
                ? application.applicationDate.split("T")[0]
                : "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Allotted Date
            </Typography>
            <Typography fontWeight={500}>
              {application?.allotedAt
                ? application.allotedAt.split("T")[0]
                : "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Allotted By
            </Typography>
            <Typography fontWeight={500}>
              {application?.allotedBy || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Conferred Date
            </Typography>
            <Typography fontWeight={500}>
              {application?.conferredDate
                ? application.conferredDate.split("T")[0]
                : "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Conferred By
            </Typography>
            <Typography fontWeight={500}>
              {application?.conferredBy || "-"}
            </Typography>
          </Grid>
        </Grid>

        {/* Important Note */}
        <Box
          sx={{
            mt: 4,
            p: 2,
            backgroundColor: "#FFF8E1",
            border: "1px solid #FFE082",
            borderRadius: "12px",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ color: "#b91c1c", fontWeight: 600, mb: 1 }}
          >
            Important Note
          </Typography>
          <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
            Are you sure you want to permanently delete this Gohonzon entry?
            <br />
            Once deleted, this record <strong>cannot be recovered</strong>.
          </Typography>
        </Box>

        {/* Buttons */}
        <Box
          mt={4}
          display="flex"
          justifyContent="center"
          gap={2}
          sx={{ paddingBottom: "10px" }}
        >
          <Button
            variant="contained"
            style={{
              ...CommonStyles.buttonStyle,
              backgroundColor: "#b91c1c",
              color: "#fff",
              minWidth: "160px",
              fontWeight: 600,
              borderRadius: "10px",
            }}
            onClick={handleDelete}
            label="Delete"
          />
          <Button
            variant="outlined"
            style={{
              ...CommonStyles.buttonStyle,
              borderColor: "#9e9e9e",
              color: "#424242",
              minWidth: "120px",
              fontWeight: 500,
              borderRadius: "10px",
            }}
            onClick={onClose}
            label="Cancel"
          />
        </Box>
      </Box>
    </Modal>
  );
}

export default GohonzonDeleteModal;
